import type { NavigationGuardReturn, RouteLocationNormalized } from 'vue-router';

import { BRAND } from '@/models/auth/permissions.enum';
import { getRouteBrandLabel } from '@/router/brand';
import { useFlagStore } from '@/stores/flag';
import { useIdentityStore } from '@/stores/identity';

export async function publishingAutopilotAccessGuard(
  to: RouteLocationNormalized,
): Promise<NavigationGuardReturn> {
  const flagStore = useFlagStore();
  const identityStore = useIdentityStore();

  // Current brand is not set until after the navigation is resolved
  // See `useBrandSwitcher.performBrandSwitch`
  const brandLabel = getRouteBrandLabel(to);
  const targetBrand = brandLabel ? identityStore.identity?.brands?.[brandLabel] : null;

  await flagStore.waitForUserFlags;
  const canAccess =
    flagStore.flags.schedulerPublishingAutopilot &&
    targetBrand &&
    identityStore.guard(BRAND.SCHEDULER.CAN_ACCESS_SCHEDULER_AUTOPILOT, targetBrand);

  if (canAccess) return true;
  if (!brandLabel) return false;
  return {
    name: 'settings.profile',
    params: { brandLabel },
  };
}
